<template>
  <!--====== Section 3: AI Studio는 무엇이 다른가 ======-->

  <section class="appie-services-2-area pb-100" id="service-details">
    <div class="container">
      <div class="row align-items-end">
        <div class="col-lg-12">
          <div class="appie-section-title text-center">
            <h3 class="appie-title" style="white-space: pre-line">{{title}}</h3>
            <p>{{description}}</p>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-lg-4 col-md-6">
          <div class="appie-single-service-2 mt-30 wow animated fadeInUp" data-wow-duration="2000ms" data-wow-delay="200ms">
            <div class="icon">
              <i class="fal fa-eye"></i>
            </div>
            <h4 class="title">AI로 기획·설계를 즉시 시각화</h4>
            <p>요구사항을 AI로 빠르게 구조화하고, 화면/기능 초안을 초기에 바로 공유합니다. "생각했던 거랑 다르다" 문제를 최소화합니다.</p>
          </div>
        </div>
        <div class="col-lg-4 col-md-6">
          <div class="appie-single-service-2 item-2 mt-30 wow animated fadeInUp" data-wow-duration="2000ms" data-wow-delay="200ms">
            <div class="icon">
              <i class="fal fa-rocket"></i>
            </div>
            <h4 class="title">AI로 개발 속도를 가속</h4>
            <p>반복 작업, 기본 구조는 AI가 처리하고 개발자는 로직·안정성·정책 대응에 집중합니다. 동일 인력 대비 훨씬 빠른 산출이 가능합니다.</p>
          </div>
        </div>
        <div class="col-lg-4 col-md-6">
          <div class="appie-single-service-2 item-3 mt-30 wow animated fadeInUp" data-wow-duration="2000ms" data-wow-delay="400ms">
            <div class="icon">
              <i class="fal fa-user-check"></i>
            </div>
            <h4 class="title">사람이 최종 책임지는 결과물</h4>
            <p>AI 결과물을 그대로 쓰지 않습니다. 스윙투앱 개발팀이 검수·보완하여 출시/운영 가능한 수준으로 완성합니다.</p>
          </div>
        </div>
      </div>

      <div class="row mt-30">
        <div class="col-lg-12 text-center">
          <p style="font-size: 18px; color: #0a44b9; font-weight: 600; margin-top: 30px;">AI는 도구이고, 결과에 책임지는 건 사람입니다.</p>
        </div>
      </div>
    </div>
  </section>

  <!--====== APPIE SERRVICE 2 PART ENDS ======-->
</template>

<script>
export default {
  props:{
    title:{
      type:String,
    },
    description:{
      type:String,
    }
  }

}
</script>

<style>

</style>
